var map = {
	"./img_1.jpg": 72298,
	"./img_10.jpg": 61779,
	"./img_2.png": 73363,
	"./img_3.png": 68350,
	"./img_4.jpg": 35366,
	"./img_5.jpg": 17422,
	"./img_6.jpg": 59643,
	"./img_7.png": 14638,
	"./img_8.jpg": 17182,
	"./img_9.jpg": 62400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3555;